<template>
    <div class="container">
        <div class="coa">
            <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="0px">
                <p>请输入批号：</p>
                <el-form-item label prop="batchNo" style = "margin-bottom:10px">
                    <el-input v-model="ruleForm.batchNo" placeholder="请输入批号" size="small"></el-input>
                </el-form-item>
                <p>请输入货号：</p>
                <el-form-item label prop="specsNo" style = "margin-bottom:10px">
                    <el-input v-model="ruleForm.specsNo" placeholder="请输入货号" size="small"></el-input>
                </el-form-item>
            </el-form>
             <button class="btn" @click="onSubmitValidate">查询</button>
        </div>
        <Hot></Hot>
    </div>
</template>

<script>

import * as apis from '../fetch/common';
import Hot from '../components/hot/Hot';

import { mapActions } from 'vuex';

export default {
    name: 'coa',
    components: {
        Hot,
    },
    data() {
        return {
            ruleForm: {
                batchNo: '',
                specsNo: '',
            },
            rules: {
                batchNo: [{ required: true, message: '请输入批号', trigger: 'blur' }],
                specsNo: [{ required: true, message: '请输入货号', trigger: 'blur' }],
            },
        };
    },
    methods: {
        onSubmitValidate() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.ruleForm };
            apis.getCoa(params).then(res => {
                window.open(res);
            });
        },        
    }

};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}

.coa {
    width: 895px;
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(228, 228, 228, 0.5);
    border-radius: 10px;
    margin-right: 10px;
    padding: 32px;
    height: max-content;
        .btn {
            width: 100px;
            line-height: 40px;
            height: 40px;
            background-color: #3c9539;
            font-size: 14px;
            color: #ffffff;
            outline: none;
        }    
}
</style>